/**
 * Wire shapes for /api/v2/admin/treatment-form (cycle-27).
 *
 * Admin controller wraps the shared TreatmentFormService responses
 * through toSnake at the wire (the service stays raw for the patient
 * app). Detail (GET /:id) projects files + history relations.
 *
 * Phase E Cycle 5 — status / gender / way_of_communication are
 * canonical BE enum strings.
 */
import { Gender } from './users';

// Phase E Cycle 5 canonical (BE system.constants).
export enum TreatmentFormStatus {
  New = 'new',
  Reviewed = 'reviewed',
  Closed = 'closed'
}

export enum WayOfCommunication {
  Email = 'email',
  Phone = 'phone',
  Whatsapp = 'whatsapp',
  None = 'none'
}

export interface TreatmentFormHistoryRow {
  id: number;
  status: TreatmentFormStatus;
  note: string | null;
  created_at: string;
  updated_at: string;
  treatment_form_id: number;
}

export interface TreatmentFormFileRow {
  id: number;
  filename: string;
}

export interface TreatmentFormListRow {
  id: number;
  first_name: string;
  last_name: string;
  email: string | null;
  phone: string | null;
  status: TreatmentFormStatus | null;
  date_of_birth: string | null;
  gender: Gender | null;
  way_of_communication: WayOfCommunication | null;
  created_at: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface TreatmentFormDetail extends TreatmentFormListRow {
  note: string | null;
  description: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  calculations: any;
  history: TreatmentFormHistoryRow[];
  files: TreatmentFormFileRow[];
}

export interface TreatmentFormListResponse {
  results: TreatmentFormListRow[];
  total: number;
}

export interface TreatmentFormListQuery {
  page?: number; // 0-based FE; service +1's
  limit?: number;
  search?: string;
}

export interface UpdateTreatmentFormInput {
  status: number | string;
  note?: string;
}
